<script>
  import BlockTitle from '../BlockTitle.svelte';
  import PortfolioWorkSlider from '../portfolio/work/Slider.svelte';
  import viewport from '@/js/utils/useViewportAction.js';

  export let portfolio;

  let blockTitle = {
    title: portfolio.title,
    desc: portfolio.desc,
  };

  let grow = false;
</script>

<section
  class="portfolio-wrap"
  class:grow
  use:viewport
  on:enterViewport={() => (grow = true)}
>
  <div class="container container--medium">
    <BlockTitle data={blockTitle} small={true} largeMobTitle={true} />

    <PortfolioWorkSlider items={portfolio.items} type="home" />
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .portfolio-wrap {
    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }

    @include resp-max('s') {
      border-top: 1px solid $light-border;
    }
  }
</style>
